export interface PriorityRulesState {
  priorityRules: PriorityRuleItem[],
  priorityRuleItem?: PriorityRuleItem
}

export interface PriorityRuleFilter {
  channel?: string,
  originator?: string,
  partner?: string,
  template?: string,
  page_number: number,
  template_priority?: number
}

export interface PriorityRuleItem {
  id?: number
  channel?: number|null,
  channel_id: number|null,
  originator?: string,
  originator_id?: number|null,
  partner?: string,
  partner_id?: number|null,
  template?: string,
  template_id?: number|null,
  template_priority: number
}

export class PriorityRuleItemImpl implements PriorityRuleItem {
  channel_id: number|null;
  template_priority: number;
  originator_id?: number|null;
  partner_id?: undefined;
  template_id?: number|null;

  constructor() {
    this.channel_id = null;
    this.template_priority = 4;
  }
}
